import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Redirect, Route} from "react-router-dom";
import Nav from "../widgets/nav/Nav";
import {allMetaSelector} from "../../reducers/meta";

const AuthenticatedRoute = ({isAuthenticated, meta, name, component: Component, ...rest}) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated ? (
                <div>
                    <Nav isAuthenticated={isAuthenticated} name={name} meta={meta}/>
                    <Component {...props} />
                </div>
            ) : (
                <Redirect to="/"/>
            )}
    />
);

AuthenticatedRoute.propTypes = {
    component: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    meta: PropTypes.shape().isRequired
};

AuthenticatedRoute.defaultProps = {};

function mapStateToProps(state) {
    return {
        isAuthenticated: !!state.auth.token,
        meta: allMetaSelector(state),
        name: state.auth.user ? state.auth.user.displayName : ""
    };
}

export default connect(mapStateToProps)(AuthenticatedRoute);



// WEBPACK FOOTER //
// ./src/components/routes/AuthenticatedRoute.js